<template>
  <div>
    <div class="mce-content-body">
      <div
        ref="contentRef"
        style="
          width: 794px;
          padding: 30px 57px;
          position: fixed;
          top: -9999px;
          left: -9999px;
          z-index: -1;
          opacity: 0;
        "
        v-html="content"
      ></div>
    </div>
    <div :class="['bg-gray-100 content px-6 py-6']" id="print" ref="areaRef">
      <div
        v-for="(item, index) in contents"
        :key="index"
        :class="['bg-gray-100 relative border-b border-dashed border-black text-black']"
        style="margin: 0"
      >
        <div
          style="width: 794px; margin: 0 auto; height: 1123px; padding: 30px 57px; position: relative"
          class="bg-white mce-content-body"
          v-html="item"
        >
        </div>
        <div
          :style="`
            height: 30px;
            position: absolute;
            bottom:0;
            left: 0;
            width: 100%;
            text-align: center;
          `"
          >{{ index + 1 }}</div
        >
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      content: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        contents: '',
      };
    },
    watch: {
      content: {
        handler() {
          this.$nextTick(() => {
            this.arrayContent();
          });
        },
        immediate: true
      }
    },
    methods: {
      arrayContent() {
        let clientHeight = 1063;
        let cs = [];
        let height = 0;
        let ctext = '';
        let children = this.$refs.contentRef.children;
        console.log(children);
        let page = 0;
        for (let index in children) {
          let i = children[index];
          if (i.nodeName == 'HR') {
            cs.push(ctext);
            height = 0;
            ctext = '';
            page++;
            continue;
          }
          if (height + i.clientHeight > clientHeight) {
            cs.push(ctext);
            ctext = i.outerHTML;
            height = i.clientHeight;
            page++;
          } else {
            height += i.clientHeight;
            ctext += i.outerHTML;
          }
          if (index == (children.length - 1).toString()) {
            cs.push(ctext);
            page++;
          }
        }
        console.log(cs);
        this.$emit('pageset', page);
        this.contents = cs;
      },
    },
  };
</script>
